import { Behavior, AttachmentRule } from './types';
import { WorldMaker } from '../WorldMaker';

export class SpawnerBehavior extends Behavior {
  private spawnInterval: number = 500; // Default 1 second in milliseconds
  private lastSpawnTime: number = 0;
  private spawnTemplate: string = ''; // Store the initial innerHTML as template

  static getAttachmentRules(): AttachmentRule[] {
    return [
      { type: 'class', selector: 'spawner' }
    ];
  }

  constructor(element: Element, world: WorldMaker) {
    super(element, world);
    this.lastSpawnTime = Date.now();
  }

  onAttach(): void {
    console.log('SpawnerBehavior attached to:', this.element);
    
    // Capture the initial innerHTML as the spawn template
    this.spawnTemplate = this.element.innerHTML;
    console.log('SpawnerBehavior: Captured spawn template:', this.spawnTemplate);
    
    // Read spawn interval from attribute if provided
    const intervalAttr = this.element.getAttribute('spawn-interval');
    if (intervalAttr) {
      const parsedInterval = parseFloat(intervalAttr);
      if (!isNaN(parsedInterval) && parsedInterval > 0) {
        this.spawnInterval = parsedInterval * 1000; // Convert seconds to milliseconds
      }
    }
    
    console.log(`SpawnerBehavior: spawn interval set to ${this.spawnInterval}ms`);
  }

  onDetach(): void {
    console.log('SpawnerBehavior detached from:', this.element);
  }

  onAttributeChange(attributeName: string, oldValue: string | null, newValue: string | null): void {
    if (attributeName === 'spawn-interval') {
      if (newValue) {
        const parsedInterval = parseFloat(newValue);
        if (!isNaN(parsedInterval) && parsedInterval > 0) {
          this.spawnInterval = parsedInterval * 1000; // Convert seconds to milliseconds
          console.log(`SpawnerBehavior: spawn interval updated to ${this.spawnInterval}ms`);
        }
      }
    }
  }

  tick(deltaTime: number): void {
    const currentTime = Date.now();
    
    // Check if it's time to spawn
    if (currentTime - this.lastSpawnTime >= this.spawnInterval) {
      this.spawn();
      this.lastSpawnTime = currentTime;
    }
  }

  private spawn(): void {
    const parent = this.element.parentElement;
    if (!parent) {
      console.warn('SpawnerBehavior: No parent element found for spawning');
      return;
    }

    // Use the captured template instead of live innerHTML
    if (this.spawnTemplate.trim() === '') {
      console.warn('SpawnerBehavior: No template to spawn');
      return;
    }

    // Create a temporary container to parse the template HTML
    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = this.spawnTemplate;
    
    // Clone each child and append to parent
    Array.from(tempContainer.children).forEach(child => {
      const clonedChild = child.cloneNode(true) as Element;
      parent.appendChild(clonedChild);
      
      // Trigger behavior attachment for the new element if the world has an attach method
      if (this.world && typeof (this.world as any).attachBehaviorsToElement === 'function') {
        (this.world as any).attachBehaviorsToElement(clonedChild);
      }
    });

    console.log(`SpawnerBehavior: Spawned ${tempContainer.children.length} children to parent`);
  }
}
